import type { TranslationKey } from "./en";

const ne: Record<TranslationKey, string> = {
  // Navigation
  "nav.projects": "परियोजनाहरू",
  "nav.newsStories": "समाचार र कथाहरू",
  "nav.aboutUs": "हाम्रो बारेमा",
  "nav.volunteer": "स्वयंसेवक",
  "nav.donateNow": "दान गर्नुहोस्",
  "nav.search": "खोज्नुहोस्",
  "nav.searchPlaceholder": "पृष्ठहरू, कार्यक्रमहरू, ब्लगहरू खोज्नुहोस्...",

  // Hero
  "hero.title": "भविष्य सशक्तिकरण",
  "hero.subtitle": "ग्रामीण नेपालमा निःशुल्क स्वास्थ्य सेवा र शिक्षा",

  // About
  "about.prefix": "बारेमा",
  "about.suffix": "निवारण",
  "about.description":
    "निवारण फाउन्डेसन एक गैर-नाफामुलक संस्था हो जसले नेपालका सबैभन्दा सेवाबाट वञ्चित समुदायहरूमा स्वास्थ्य सेवा पुर्‍याउँछ। प्रोजेक्ट सञ्जीवनीमार्फत 16 स्वास्थ्य शिविर सम्पन्न भई 17,355 बिरामीहरूले सेवा पाएका छन्, र तपाईंको हरेक दानले जीवन बचाउँछ।",

  // Stats / Happiness
  "stats.healthCamps": "सम्पन्न स्वास्थ्य शिविर",
  "stats.patients": "सेवा प्राप्त बिरामी",
  "stats.volunteers": "विश्वव्यापी स्वयंसेवकहरू",
  "stats.programs": "सक्रिय कार्यक्रमहरू",

  // Donation
  "donate.title": "तपाईं देख्न चाहनुभएको परिवर्तन बन्नुहोस्",
  "donate.subtitle":
    "तपाईंको सहयोगले नेपालमा हाम्रो कामलाई सहयोग गर्छ।",
  "donate.seeImpact": "तपाईंको दानको प्रभाव हेर्नुहोस्",
  "donate.whyTrust": "दाताहरूले किन निवारणमाथि भरोसा गर्छन्",

  // Donation Progress
  "donationProgress.title": "२०२५ वार्षिक अभियान",
  "donationProgress.subtitle":
    "हाम्रो लक्ष्य पूरा गर्न र जीवनरक्षक स्वास्थ्य र शिक्षा कार्यक्रमहरू विस्तार गर्न सहयोग गर्नुहोस्",
  "donationProgress.amountRaised": "संकलित रकम",
  "donationProgress.ourGoal": "हाम्रो लक्ष्य",
  "donationProgress.campaignStatus": "अभियानको स्थिति",
  "donationProgress.funded": "पूरा भयो",
  "donationProgress.progress": "प्रगति",
  "donationProgress.complete": "पूर्ण",
  "donationProgress.generousDonors": "उदार दाताहरू",
  "donationProgress.daysRemaining": "बाँकी दिनहरू",
  "donationProgress.toGoal": "लक्ष्यसम्म",
  "donationProgress.donateNow": "अहिले दान गर्नुहोस्",

  // Impact Calculator
  "impact.title": "तपाईंको प्रभाव हेर्नुहोस्",
  "impact.subtitle":
    "तपाईंले दान गर्नुभएको हरेक डलरले सिधै नेपालमा जीवन बचाउन र समुदायहरू रूपान्तरण गर्न मद्दत गर्छ। तपाईंको उदारताले सिर्जना गर्ने वास्तविक प्रभाव हेर्न कुनै पनि रकम चयन गर्नुहोस्।",
  "impact.chooseAmount": "तपाईंको दान छान्नुहोस्",
  "impact.amount": "रकम (USD)",
  "impact.quickSelect": "छिटो चयन",
  "impact.donateThis": "यो रकम दान गर्नुहोस्",
  "impact.directToPrograms": "वित्तीय प्रतिवेदनको स्थिति हेर्नुहोस्",

  // Projects
  "projects.prefix": "हाम्रा",
  "projects.suffix": "परियोजनाहरू",

  // Newsletter
  "newsletter.title": "अद्यावधिक रहनुहोस्",
  "newsletter.subtitle":
    "स्वास्थ्य शिविर, सामुदायिक कार्यक्रमहरू, र सहयोगका तरिकाहरूबारे नवीनतम समाचारका लागि हाम्रो न्यूजलेटर सदस्यता लिनुहोस्।",
  "newsletter.placeholder": "तपाईंको इमेल प्रविष्ट गर्नुहोस्",
  "newsletter.subscribe": "सदस्यता लिनुहोस्",

  // Footer
  "footer.ourWorks": "हाम्रो कामहरू",
  "footer.usefulLinks": "उपयोगी लिंकहरू",
  "footer.nonprofit": "अमेरिकी कर-छुट मान्यता प्राप्त भएको छैन | EIN: 41-2656587",
  "footer.location": "बोस्टन, MA अमेरिका",
  "footer.copyright": "सर्वाधिकार सुरक्षित।",

  // Common
  "common.learnMore": "थप जान्नुहोस्",
  "common.readMore": "थप पढ्नुहोस्",
  "common.viewAll": "सबै हेर्नुहोस्",
  "common.loading": "लोड हुँदैछ...",
  "common.home": "गृहपृष्ठ",
  "common.donate": "दान",

  // Cookie Consent
  "cookie.message":
    "हामी तपाईंको अनुभव सुधार गर्न कुकीहरू प्रयोग गर्छौं। जारी राखेर, तपाईं हाम्रो कुकी प्रयोगमा सहमत हुनुहुन्छ।",
  "cookie.accept": "स्वीकार गर्नुहोस्",
  "cookie.decline": "अस्वीकार गर्नुहोस्",

  // 404
  "notFound.title": "पृष्ठ भेटिएन",
  "notFound.message":
    "तपाईंले खोज्नुभएको पृष्ठ फेला पार्न सकिएन। निवारण फाउन्डेसनको गृहपृष्ठमा फर्कनुहोस्।",
  "notFound.goHome": "गृहपृष्ठमा जानुहोस्",

  // Language
  "lang.toggle": "English",
  "lang.current": "ने",
};

export default ne;
